import { render, staticRenderFns } from "./GlobalComponent.vue?vue&type=template&id=e59cb5d0&"
import script from "./GlobalComponent.vue?vue&type=script&lang=js&"
export * from "./GlobalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports